import { Customer, Railroad, FieldWorker, JobSummary } from 'src/shared/api';
import { createAction, props } from '@ngrx/store';
import { CustomerDetails } from '../customer-detail.models';
import { TouchableControl } from 'src/shared/models/TouchableControl';

export const customerSaved = createAction(
	'[Customers] Customer Saved',
	props<{ customer: Customer }>()
);

export const saveRequestedWithInvalidForm = createAction(
	'[Customers] Save Requested With Invalid Form',
	props<{ controls: TouchableControl[] }>()
);

export const formErrorCleared = createAction('[Customers] Form Error Cleared');

export const newCustomerSaved = createAction(
	'[Customers] New Customer Saved',
	props<{ customer: Customer }>()
);

export const railroadsLoaded = createAction(
	'[Customers] Railroads Loaded',
	props<{ railroads: Railroad[] }>()
);

export const rwicsLoaded = createAction(
	'[Customers] Rwics Loaded',
	props<{ rwics: FieldWorker[] }>()
);

export const jobsLoaded = createAction(
	'[Customers] Jobs Loaded',
	props<{ jobs: JobSummary[] }>()
);

export const errorSavingCustomer = createAction(
	'[Customers] Error Saving Customer',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Customers] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: CustomerDetails }>()
);

export const customerDetailDestroyed = createAction(
	'[Customers] Customer Detail Destroyed'
);

export const customerSelected = createAction(
	'[Customers] Customer Selected',
	props<{ customerId: number }>()
);

export const customerLoadedFromApi = createAction(
	'[Customers] Customer Loaded From Api',
	props<{ customer: Customer }>()
);

export const customerLoadedFromStore = createAction(
	'[Customers] Customer Loaded From Store',
	props<{ customer: Customer }>()
);

export const errorLoadingCustomer = createAction(
	'[Customers] Error Loading Customer',
	props<{ error: any }>()
);

export const newCustomerContinued = createAction(
	'[Customers] New Customer Continued',
	props<{ customer: Customer }>()
);

export const newCustomerStarted = createAction(
	'[Customers] New Customer Started'
);
